<mat-form-field style="width: 100%">
    <mat-select
        placeholder="Tierart"
        [formControl]="tierartCtrl"
        (selectionChange)="tierartChanged($event)"
        [compareWith]="tierartComparator"
        #selector
    >
        <mat-option>Keine</mat-option>
        <mat-option *ngFor="let t of tierarten" [value]="t">{{ t.tierart }}</mat-option>
    </mat-select>
</mat-form-field>
